import {app} from '../app';

export class SpinnerComponent {

    constructor() {

    }

}

app.component('spinner', {
    templateUrl: 'templates/components/spinner.html',
    controller: SpinnerComponent,
    controllerAs: 'spinnerComponent',
});